/**
 * Information about the customer.
 * Either the customer id or firstName and lastName have to be set.
 */
export class OrderCustomerInformation {
  /** DMS specific customer number. Required when communicating to a DMS. */
  dmsCustomerId?: string;

  /** BMW Group-wide globally unique customer ID assigned in GCDM system. */
  gcdmCustomerId?: string;

  /** First name of the person (if natural person). */
  firstName?: string;

  /** Last name of the person (if natural person). */
  lastName?: string;

  /** Company name (if legal person). */
  companyName?: string;
}
